import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import { EventService } from "src/app/services/event.service";
import { ClaimActionsService } from "src/app/pages/customer-dashboard/services/claim-actions.service";
import { SelectionModel } from "@angular/cdk/collections";
import { CreatePurchaseItemComponent } from "./modal/create-purchase-item/create-purchase-item.component";
@Component({
  selector: "fury-purchase-claim",
  templateUrl: "./purchase-claim.component.html",
  styleUrls: ["./purchase-claim.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PurchaseClaimComponent implements OnInit, OnDestroy, OnChanges {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input() claimUserId = "";
  @Input() tabName = "";
  @Input()
  columns = [
    { name: "Select", property: "select", visible: true, isModelProperty: true},
    { name: "Created At", property: "createdAt", visible: true },
    { name: "Agreement Number", property: "agreementNumber", visible: true },
    { name: "Claim Number", property: "fileClaimNumber", visible: true },
    { name: "Status", property: "status", visible: true },
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last name", property: "lastName", visible: true },
    { name: "Phone Number", property: "phoneNumber", visible: true },
    { name: "Email Address", property: "emailAddress", visible: true },
    { name: "Address", property: "address", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip", property: "zip", visible: true },
    { name: "Covered Item", property: "coveredItem", visible: true },
    { name: "Transaction Id", property: "transactionId", visible: true },
    { name: "Card Type", property: "cardType", visible: true },
    { name: "Amount", property: "amount", visible: true },
    { name: "Availability", property: "availability", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  @Input() pageIndex: number = 0;
  ngUnsubscribe = new Subject<void>();
  claimSearchForm = new FormGroup({
    agreementNumber: new FormControl(""),
    claimNumber: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    phoneNumber: new FormControl(""),
    emailAddress: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    coveredItem: new FormControl(""),
    status: new FormControl(""),
  });
  status = [];
  selection = new SelectionModel(true, []);

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
    public claimActionsService: ClaimActionsService,
    private eventService: EventService
  ) {}
  ngOnInit(): void {
    this.filterValue = "Purchased Claim";
    this.router.onSameUrlNavigation = "reload";
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.getPurchaseClaims();
      });
    this.getAllStatus();
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    if(this.claimUserId){
      this.getPurchaseClaims();
    } else {
      this.router.navigateByUrl(
        `/file-claim/purchase-claim?page=${this.pageIndex + 1}${
          this.pageSize
            ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
            : ""
        }`
      );
    }
  }

  getPurchaseClaims() {
    const {
      firstName,
      lastName,
      claimNumber,
      agreementNumber,
      phoneNumber,
      emailAddress,
      address,
      city,
      state,
      zip,
      status,
      coveredItem,
    } = this.claimSearchForm.value;
    const queryParams = `?page=${Number(this.pageIndex) + 1}&size=${
      this.pageSize
    }&firstName=${firstName}&lastName=${lastName}&claimNumber=${claimNumber}&agreementNumber=${agreementNumber}&phoneNumber=${phoneNumber}&emailAddress=${emailAddress}&address=${address}&city=${city}&state=${state}&zip=${zip}&status=${status}&coveredItem=${coveredItem}`;
    this.apiservice
      .get(
        `${endpoints.fileAClaim.getPurchaseClaims}${
          this.claimUserId ? `/${this.claimUserId}` : ""
        }${queryParams}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res?.body?.fileClaims) {
              this.itemList = res?.body?.fileClaims?.data;
              this.totalCount = res?.body?.fileClaims.total;
              this.dataSource = new MatTableDataSource(this.itemList);
              this.selection.clear();
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.apiservice.alert(err.message, ErrorType.Error);
        }
      );
  }
  getAllStatus() {
    this.eventService.getClaimStatus$.subscribe((status: any[]) => {
      this.status = status;
    });
  }
  redirectToPurchasedItemsPage(claimId: string) {
    this.router.navigateByUrl(
      `/file-claim/purchase-claim/purchased-items/${claimId}`
    );
  }
  multiPurchaseItem() {
    if (this.selection.selected.length === 0) {
      this.apiservice.alert(
        "Please select at least one claim",
        ErrorType.Error
      );
      return;
    }
    const purchaseData = {
      claimId: this.selection.selected.map((item) => item?.fileClaimId),
      purchaseItem: null,
    };
    this.dialog
      .open(CreatePurchaseItemComponent, {
        data: purchaseData,
        width: "800px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) {
          this.getPurchaseClaims();
        }
      });
  }
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes?.tabName.currentValue === "Purchase Claims" &&
      !changes?.tabName.firstChange
    ) {
      this.getPurchaseClaims();
    }
  }
  redirectToViewClaim(claimDetails: any) {
    this.router.navigateByUrl(`/customer-dashboard/${claimDetails?.userId}/view-claim/${claimDetails?.fileClaimId}`);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
